import { render, staticRenderFns } from "./Paragraph.vue?vue&type=template&id=5b9db084&scoped=true&"
import script from "./Paragraph.vue?vue&type=script&lang=ts&"
export * from "./Paragraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9db084",
  null
  
)

export default component.exports